import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import FAQAccordionItem from './FAQAccordionItem';

const FAQAccordion = ({ data, theme, openMultiple }) => {
  const [currentIndex, setCurrentIndex] = useState(null);
  const faqAccordionRef = useRef(null);

  const clickHeader = index => {
    faqAccordionRef.current.children[index]
      .querySelector('.faq-accordion-item__top')
      .click();
  };

  useEffect(() => {
    if (!openMultiple) {
      const initIndex = data.findIndex(faqItem => faqItem.isOpened);
      if (initIndex > -1) {
        setCurrentIndex(initIndex);
        clickHeader(initIndex);
      }
    }
  }, [data, openMultiple]);

  const handleCollpsedChange = (value, index) => {
    if (!openMultiple) {
      if (currentIndex) {
        clickHeader(currentIndex);
      }
      if (!value) {
        setCurrentIndex(index);
        clickHeader(index);
      } else {
        setCurrentIndex(null);
      }
    }
  };

  return (
    <div className="faq-accordion" ref={faqAccordionRef}>
      {data.map((faqItem, index) => (
        <FAQAccordionItem
          key={faqItem.top}
          top={faqItem.top}
          content={faqItem.content}
          isOpened={openMultiple ? faqItem.isOpened : null}
          theme={theme}
          onCollapsedChange={value => handleCollpsedChange(value, index)}
        />
      ))}
    </div>
  );
};

FAQAccordion.themes = FAQAccordionItem.themes;

FAQAccordion.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      top: PropTypes.node.isRequired,
      content: PropTypes.node.isRequired,
      isOpened: PropTypes.bool
    })
  ).isRequired,
  theme: PropTypes.oneOf(Object.keys(FAQAccordionItem.themes)),
  openMultiple: PropTypes.bool
};

FAQAccordion.defaultProps = {
  theme: null,
  openMultiple: false
};

export default FAQAccordion;
